import styled from 'styled-components';
import { contextList } from './Toast';

export const coloByContext = (context = 'positive') => ({
  [contextList.positive]: '#35CF8B',
  [contextList.neutral]: '#74C1FF',
  [contextList.alert]: '#FF9442',
  [contextList.negative]: '#F16A5E',
  [contextList.error]: '#DA4336',
})[context];

export const Container = styled.dialog`
  border-radius: 8px;
  margin: 0 20px 10px 20px;
  padding: 16px;
  border: 0;
  background: #1F2044;
  display: flex;
  gap: 10px;
  font-family: 'Galano';

  ${({ error }) => error && `
    background-color: #DA4336;
    button, p, div {
      color: #ffffff;
    };
  `}
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  p {
    margin: 0;
    padding: 0;
  }
`;

export const Title = styled.p`
  color: #fff;
  font-weight: 700;
  font-size: 16px;

  ${({ context }) => context !== contextList.error && `
    color: ${coloByContext(context)};
  `}
`;

export const Info = styled.p`
  font-weight: 500;
  color: #CDD8DF;
  font-size: 14px;
`;

export const Actions = styled.div`
  margin: 0 3px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  align-content: center;
`;

export const Close = styled.button`
  align-content: center;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: 0;
  cursor: pointer;

  ${({ hasActionsButton }) => hasActionsButton && `
    align-content: start;
  `}

  span {
    display: block;
    cursor: pointer;
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: 24px;
`;

export const Button = styled.button`
  font-weight: 500;
  font-size: 14;
  font-family: 'Galano';
  border-radius: 1000px;
  background-color: transparent;
  padding: 7px 20px;
  color: #fff;
  cursor: pointer;

  &:active, :focus, :focus-visible {
    outline: none;
  }

  ${({ variant }) => variant === 'primary' && `
    border: 1px solid #fff;
  `}

  ${({ variant }) => variant === 'secondary' && `
    border: 0;
  `}
`;
